import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-payment-success',
  templateUrl: './modal-payment-success.component.html',
  styleUrls: ['./modal-payment-success.component.scss']
})
export class ModalPaymentSuccessComponent implements OnDestroy {

  constructor(public modal: ModalService) { }

  ngOnDestroy() {
    this.modal.close();
  }

}
